/**
 * CMS Metadata Parsing
 *
 * Utilities for parsing raw CMS metadata fields into typed behavior data arrays.
 * CMS backends store scene root behaviors as a JSON string in a `metadata` field;
 * this module handles parsing that field safely.
 */

import type { BehaviorData } from '../scenedata/behaviordata';

/**
 * Parse raw CMS metadata into a BehaviorData array.
 * Handles both pre-parsed arrays and JSON strings. Returns undefined for
 * invalid input (non-array, malformed JSON, null/undefined).
 */
export function parseCmsMetadata(raw: unknown): BehaviorData[] | undefined {
    const parsed: unknown = typeof raw === 'string'
        ? (() => { try { return JSON.parse(raw) as unknown; } catch { return undefined; } })()
        : raw;
    return Array.isArray(parsed) ? parsed as BehaviorData[] : undefined;
}
